module.exports = __webpack_public_path__ + "static/media/LogoSU.40fe92bd.svg";